var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dense":""}},[_c('v-container',[_c('v-col',{staticClass:"text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v(_vm._s(_vm.messageFooter)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }